import { render, staticRenderFns } from "./SimpleTrainerCard.vue?vue&type=template&id=a3a9ed0c&scoped=true&"
import script from "./SimpleTrainerCard.vue?vue&type=script&lang=js&"
export * from "./SimpleTrainerCard.vue?vue&type=script&lang=js&"
import style0 from "./SimpleTrainerCard.vue?vue&type=style&index=0&id=a3a9ed0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a9ed0c",
  null
  
)

export default component.exports